import { zodResolver } from '@hookform/resolvers/zod'
import { Login } from '@mui/icons-material'
import { LoadingButton } from '@mui/lab'
import { Alert, Button, Paper } from '@mui/material'
import Box from '@mui/material/Box'
import Container from '@mui/material/Container'
import Grid from '@mui/material/Grid'
import Typography from '@mui/material/Typography'
import { FormInput } from 'components/FormItem/form-input'
import { useUser } from 'contexts/userContext'
import * as React from 'react'
import { useForm } from 'react-hook-form'
import { useLocation, useNavigate } from 'react-router-dom'
import { ILocationProps } from 'types/locationProps'
import { z } from 'zod'

const signInSchema = z.object({
  email: z
    .string({ required_error: 'É necessário preencher o email' })
    .email('É necessário preencher um email válido'),
  password: z.string({ required_error: 'É necessário preencher a senha' }),
})

type SignInForm = z.infer<typeof signInSchema>

export default function SignInPage() {
  const { login, loading, user, errorMessage } = useUser()
  const location = useLocation() as ILocationProps
  const navigate = useNavigate()

  const from = location.state?.from?.pathname ?? '/'
  const fromState = location.state?.from?.state

  React.useEffect(() => {
    const token = localStorage.getItem('user_token')
    const storageUser = localStorage.getItem('user')
    if (token && storageUser && user) {
      navigate(from, { replace: true, state: fromState })
    }
  }, [from, fromState, navigate, user])

  const form = useForm<SignInForm>({
    resolver: zodResolver(signInSchema),
    defaultValues: {
      email: '',
      password: '',
    },
  })

  const onSubmit = form.handleSubmit((data: SignInForm) => {
    login(data.email.trim(), data.password)
  })

  return (
    <Container component={Paper} maxWidth="xs">
      <Box
        sx={{
          my: 2,
          py: 2,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >
        <img
          src="https://images.zedoingresso.com.br/zedoingresso/imgs/header-logo.png"
          alt="Zé do Ingresso"
          height={50}
        />
        <Typography component="h1" variant="h5" sx={{ mt: 2 }}>
          Informe o e-mail e senha
        </Typography>
        {errorMessage && <Alert severity="error">{errorMessage}</Alert>}
        <form onSubmit={onSubmit}>
          <FormInput control={form.control} name="email" />
          <FormInput control={form.control} name="password" type="password" />
          <LoadingButton
            loading={loading}
            loadingPosition="end"
            endIcon={<Login />}
            type="submit"
            fullWidth
            variant="contained"
            size="large"
            sx={{ mt: 3, mb: 2 }}
          >
            Entrar
          </LoadingButton>
          <Grid container sx={{ justifyContent: 'space-between' }}>
            <Grid item>
              <Button
                variant="outlined"
                onClick={() => navigate('/esqueci-senha')}
                size="small"
              >
                Esqueci a senha
              </Button>
            </Grid>
            <Grid item>
              <Button
                variant="outlined"
                onClick={() => navigate('/signup')}
                size="small"
              >
                Criar conta
              </Button>
            </Grid>
          </Grid>
        </form>
      </Box>
    </Container>
  )
}
